import { useMemo, useState } from 'react'

import { Box, useMediaQuery, VStack } from '@chakra-ui/react'

import { useGetHeaderInfoQuery } from '@core/app/api/profileApi'
import { Footer } from '@core/components/Footer/Footer'
import { Header } from '@core/components/Header/Header'
import { MobileHeader } from '@core/components/mobileHeader/mobileHeader'
import { useAppTheme } from '@core/utils/contexts/ThemeContext/ThemeContext'

import { About } from '@page/company/components/Sections/About'
import { Advantages } from '@page/company/components/Sections/Advantages'
import { Hero } from '@page/company/components/Sections/Hero'
import { Jobs } from '@page/company/components/Sections/Jobs'
import { Movie } from '@page/company/components/Sections/Movie'
import { PopularJobs } from '@page/company/components/Sections/PopularJobs'
import { Quote } from '@page/company/components/Sections/Quote'
import { Recruiters } from '@page/company/components/Sections/Recruiters'

export const Constructor = () => {
    const { appTheme } = useAppTheme()
    const [isDesktop] = useMediaQuery('(min-width: 1230px)')
    const { data: headerInfo, isLoading } = useGetHeaderInfoQuery({})
    const [isFeedbackMenu, setIsFeedbackMenu] = useState(false)
    const [selectedFeedback, setSelectedFeedback] = useState<number | null>(null)

    const memoTheme = useMemo(() => {
        return appTheme
    }, [appTheme])

    const isSectionsExist =
        appTheme?.newSettings?.landing &&
        appTheme?.newSettings.landing.structure &&
        appTheme.newSettings.landing.structure.sections &&
        Object.keys(appTheme.newSettings?.landing?.structure?.sections || {}).length > 0

    const currentLocaleId = Object.values(headerInfo?.locale?.current || {})[0]?.id || appTheme?.languageId

    const renderSection = (name: string, id: number) => {
        switch (name) {
            case 'Header':
                return (
                    <Header
                        key={name}
                        // fixedHeader={true}
                        isFeedbackMenu={isFeedbackMenu}
                        setIsFeedbackMenu={setIsFeedbackMenu}
                        selectedFeedback={selectedFeedback}
                        setSelectedFeedback={setSelectedFeedback}
                    />
                )
            case 'Hero':
                return <Hero key={name} id={id} headerInfo={headerInfo} languageId={currentLocaleId} />
            case 'Video':
                return <Movie key={name} id={id} />
            case 'About':
                return <About key={name} id={id} languageId={currentLocaleId} />
            case 'Popular jobs':
                return <PopularJobs key={name} id={id} languageId={currentLocaleId} />
            case 'Advantages':
                return <Advantages key={name} id={id} languageId={currentLocaleId} />
            case 'Quote':
                return <Quote key={name} id={id} languageId={currentLocaleId} />
            case 'Recruiters':
                return <Recruiters key={name} id={id} languageId={currentLocaleId} />
            case 'Jobs':
                return <Jobs key={name} id={id} languageId={currentLocaleId} />
            case 'Footer':
                return (
                    <Box justifySelf="end">
                        <Footer key={name} />
                    </Box>
                )
            case 'MobileHeader':
                return (
                    !isDesktop && (
                        <MobileHeader
                            isFeedbackMenu={isFeedbackMenu}
                            setIsFeedbackMenu={setIsFeedbackMenu}
                            selectedFeedback={selectedFeedback}
                            setSelectedFeedback={setSelectedFeedback}
                        />
                    )
                )
            default:
                return null
        }
    }

    if (!isSectionsExist) {
        return <Header />
    }

    if (memoTheme && isSectionsExist) {
        return (
            <div
                style={{
                    minHeight: '100vh',
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                {renderSection('Header', 0)}
                {renderSection('MobileHeader', 0)}

                <main style={{ flex: '1 0 auto' }}>
                    {Object.values(memoTheme?.newSettings?.landing?.structure?.sections || {}).map((item) =>
                        renderSection(item.name, item.id)
                    )}
                </main>

                {renderSection('Footer', 0)}
            </div>
        )
    }
    return null
}
